export interface RecipeTimeFacts {
  totalTimeMinutes?: number | null;
  prepTimeMinutes?: number | null;
  cookTimeMinutes?: number | null;
}

function knownMinutes(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0;
}

/** Prefer a stated total; derive one only when both components are known. */
export function recipeTotalMinutes(recipe: RecipeTimeFacts): number | null {
  if (recipe.totalTimeMinutes !== undefined && recipe.totalTimeMinutes !== null)
    return knownMinutes(recipe.totalTimeMinutes) ? recipe.totalTimeMinutes : null;
  if (!knownMinutes(recipe.prepTimeMinutes) || !knownMinutes(recipe.cookTimeMinutes)) return null;
  const sum = recipe.prepTimeMinutes + recipe.cookTimeMinutes;
  return Number.isFinite(sum) ? sum : null;
}

export type RecipeIngredientAmountKind = 'measured' | 'to_taste' | 'as_needed' | 'unspecified';

/** A total is known only if every contributing amount is known, including zero. */
export function sumKnownAmounts(values: readonly (number | null | undefined)[]): number | null {
  let total = 0;
  for (const value of values) {
    if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) return null;
    total += value;
  }
  return Number.isFinite(total) ? total : null;
}
